import * as React from 'react'

import { Card, TogglerCheckbox } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

interface Props {
  value: boolean
  disabled?: boolean
  onChange: (value: boolean) => void
}

const Payable = ({ value, disabled, onChange }: Props) => (
  <Card extra={{ 'data-intercom-target': 'leave-type-payable-input' }}>
    <Card.Title
      size="small"
      action={<TogglerCheckbox value={value} disabled={disabled} onChange={onChange} />}
    >
      {i18n.t('settings.leave_types.page.allowance.form.payable.label')}
    </Card.Title>
    <Card.Description>
      {i18n.t('settings.leave_types.page.allowance.form.payable.description')}
    </Card.Description>
  </Card>
)

export default Payable
